import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';

import AppContext from '@/contexts/appContext';

import type { Props } from './types';

/**
 * NOTE: This component is business/domain-specific and does not belong in the
 * generic UI primitives library (ui/components). It should be moved to a more
 * appropriate domain-specific location in the codebase.
 */
const AuditLogLink = ({ entityType, entityId, className, children }: Props) => {
  const { host } = useContext(AppContext);

  return (
    <a
      target="_blank"
      rel="noreferrer"
      href={`${host}/agent/audit_logs/${entityType}/${entityId}`}
      className={`text-blue-800 hover:underline ${className || ''}`}>
      <FontAwesomeIcon icon={faClockRotateLeft} />
      {children && <span className="ml-1">{children}</span>}
    </a>
  );
};

export default React.memo(AuditLogLink);
